import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class MtmAdminGuard {
  constructor(
    private readonly route: Router,
    private readonly authService: AuthService,
    public permissionService: PermissionService
  ) {}

  /**
   * Validate if user is ADMIN. If not, redirect to Projects page
   * @param route
   * @param state
   * @returns {boolean}
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // If no logged in, redirect to /login
    if (!this.authService.getAuthUser()) {
      this.route.navigate(['/entry']);
      return false;
    }

    // Check if user is ADMIN
    if (this.permissionService.isPlatformAdmin()) {
      return true;
    } else {
      this.route.navigate(['/projects']);
      return false;
    }
  }
}
